import React, { createContext, useContext, useMemo } from "react";

interface CspContextValue {
    nonce: string;
}

const CspContext = createContext<CspContextValue>({
    nonce: "",
});

export function CspContextProvider({
    nonce,
    children,
}: Readonly<CspContextValue & { children: React.ReactNode }>): JSX.Element {
    const value = useMemo(() => ({ nonce }), [nonce]);
    return <CspContext.Provider value={value}>{children}</CspContext.Provider>;
}

export function useCspNonce(): CspContextValue {
    return useContext(CspContext);
}
